/** PBHOrdersSQLOnly OData MaxTop (EnableQuery validation). */
export const SQL_ONLY_ODATA_MAX_TOP = 50;

/**
 * Map a requested page size to a safe OData `$top`.
 *
 * Legacy download code used `rows: 0` to mean “export / fetch all”. That must
 * never become `$top=0` (OData returns an empty page). Null/0/invalid → max top.
 */
export const clampSqlOnlyODataTop = (
  rows: number | null | undefined,
): number => {
  if (rows == null || rows === 0) {
    return SQL_ONLY_ODATA_MAX_TOP;
  }
  const numeric = Number(rows);
  if (!Number.isFinite(numeric) || numeric < 0) {
    return SQL_ONLY_ODATA_MAX_TOP;
  }
  return Math.min(numeric, SQL_ONLY_ODATA_MAX_TOP);
};
